import React from 'react';
import style from './style.module.scss';
import { ExternalLink, Headline, HtmlContainer, Section } from '@n2-common/ui';
import { useStatusPageLoaderData } from './loader';

export * from './loader';

type StatusPageProps = { linkKey?: Parameters<typeof ExternalLink>[0]['linkKey'] };

export default function StatusPage({ linkKey }: StatusPageProps) {
    const data = useStatusPageLoaderData();
    return <StatusPageComponent {...data} linkKey={linkKey} />;
}

export function StatusPageComponent({ heading, subheading, body, linkKey, linkText }: ReturnType<typeof useStatusPageLoaderData> & StatusPageProps) {
    return (
        <div className={style.wrapper}>
            {heading && <Headline level={1}>{heading}</Headline>}
            {subheading && <Headline level={3}>{subheading}</Headline>}
            {body && (
                <Section>
                    <HtmlContainer innerHtml={body} />
                </Section>
            )}
            {linkKey && linkText && (
                <Section>
                    <ExternalLink linkKey={linkKey} rel="noopener noreferrer" target="_blank" className={style.underlined}>
                        {linkText}
                    </ExternalLink>
                </Section>
            )}
        </div>
    );
}
